export default __webpack_public_path__ + "static/media/starts.58b6d4d8.jpg";